/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './CardsProducts.css'
import vcIpad from "assets/img/mockups/listen-first-ipad.png";
import elcarIpad from "assets/img/mockups/iPad ELCAR.png";
import { Link } from "react-router-dom"; 

// reactstrap components
import {
    Badge,
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
    CardImg,
} from "reactstrap";

class CardsProducts extends React.Component {

    render() {
        return (
            <>
                <section id="products-section" className="section section-lg">
                    <Container className="products-container">
                            
                        <h2 className="mb-3">Our Educational Products</h2>
                        <p className="mb-5">
                            Explore our products and find the perfect solution for your needs!
                        </p>
                            
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <Row className="row-grid">
                                    <Col lg="6">

                                        <Link to="/listen-first" style={{ textDecoration: 'none' }}>
                                            <Card className="card-lift--hover shadow border-0">
                                                <CardImg
                                                    alt="iPad with Listen First home screen"
                                                    src={vcIpad}
                                                    top
                                                    className="card-img"
                                                />
                                                <CardBody className="p-4">
                                                    
                                                    <h6 className="product-title">
                                                        Listen First
                                                    </h6>
                                                    <p className="description mt-3">
                                                        A groundbreaking app that translates the Fred S. Keller 
                                                        protocols into an accessible mobile platform.
                                                        
                                                    </p>
                                                    <br/>
                                                    <div className="d-flex justify-content-end shop-button">
                                                        <Button
                                                            id="button-secondary"
                                                            className="mt-4"
                                                            color="primary"
                                                        >
                                                            Shop now 

                                                            <span className="btn-inner--icon ml-2"> 
                                                                <i id="shop-icon" className="ni ni-bold-right" /> 
                                                            </span>
                                                        </Button>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col lg="6">
                                        <Link to="/elcar" style={{ textDecoration: 'none' }}>
                                    
                                        
                                            <Card className="card-lift--hover shadow border-0">
                                                <CardImg
                                                        alt="iPad with ELCAR home screen"
                                                        src={elcarIpad}
                                                        top
                                                        className="card-img"
                                                />
                                                <CardBody className="p-4">
                                                    
                                                    <h6 className="product-title">
                                                        ELCAR
                                                    </h6>
                                                    <p className="description mt-3">
                                                        A research-based approach to verbal behavior development that 
                                                        combines assessment, curriculum, and training to maximize learner
                                                        outcomes.
                                                    </p>
                                                    
                                                    <div className="d-flex justify-content-end">
                                                        <Button
                                                            id="button-secondary"
                                                            className="mt-4"
                                                            color="primary"
                                                        >
                                                            Shop now 

                                                            <span className="btn-inner--icon ml-2"> 
                                                                <i className="ni ni-bold-right" /> 
                                                            </span>
                                                        </Button>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </Link>
                                    </Col>
                                    
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </>
        )
    }
}

export default CardsProducts;